// Gemeinsamer Stand der Erinnerungs-Karten (Agent 4A, Korrektur Runde 4): wie viele Erinnerungen offen sind und ob die
// Karten unten rechts ausgeklappt sind. Der Banner (`components/ErinnerungBanner.tsx`) schreibt, die Glocke in der Kopfzeile
// liest und klappt auf. Die Karten klappen nach einer Weile von allein ein, damit sie keine Bedienelemente verdecken;
// die Zahl bleibt an der Glocke stehen.
import { useSyncExternalStore } from "react";

export interface ErinnerungStand {
  anzahl: number;
  offen: boolean;
}

/** So lange bleiben neue Karten stehen, bevor sie einklappen (wenn die Maus nicht darauf liegt). */
export const EINKLAPPEN_NACH_MS = 20_000;

let stand: ErinnerungStand = { anzahl: 0, offen: false };
const hoerer = new Set<() => void>();

function setze(teil: Partial<ErinnerungStand>): void {
  const neu = { ...stand, ...teil };
  if (neu.anzahl === stand.anzahl && neu.offen === stand.offen) return;
  stand = neu;
  hoerer.forEach((f) => f());
}

export const erinnerungAnzahlSetzen = (anzahl: number): void => setze({ anzahl, ...(anzahl === 0 ? { offen: false } : {}) });
export const erinnerungOffenSetzen = (offen: boolean): void => setze({ offen });
export const erinnerungUmschalten = (): void => setze({ offen: !stand.offen });

function abonnieren(f: () => void): () => void {
  hoerer.add(f);
  return () => {
    hoerer.delete(f);
  };
}

export function useErinnerungStand(): ErinnerungStand {
  return useSyncExternalStore(abonnieren, () => stand);
}
